import {EditorsPicksProps, LinkProps} from '@/organisms/Beta/Navigation/typings';
import {CurrencySymbol} from '@/redux/reducers/typings';

export const sharedNavigationMap = (
  editorsPicks: EditorsPicksProps[],
  currencySymbol: CurrencySymbol = '£',
): LinkProps[] => {
  return [
    {
      text: 'All art',
      link: '/art/',
    },
    {
      text: 'Painting',
      link: '/art/product_category-painting/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-painting/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-painting/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-painting/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-painting/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-painting/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-painting/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-painting/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-painting/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-painting/subject-still-life/',
            },
          ],
        },
        {
          title: 'Medium',
          links: [
            {
              text: 'Acrylic',
              link: '/art/product_category-painting/painting-painting-acrylic/',
            },
            {
              text: 'Gouache',
              link: '/art/product_category-painting/painting-painting-gouache/',
            },
            {
              text: 'Mixed media',
              link: '/art/product_category-painting/painting-painting-mixed-media/',
            },
            {
              text: 'Oil',
              link: '/art/product_category-painting/painting-painting-oil/',
            },
            {
              text: 'Spray & graffiti',
              link: '/art/product_category-painting/painting-painting-spray-paint/',
            },
            {
              text: 'Watercolour',
              link: '/art/product_category-painting/painting-painting-watercolour/',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-painting/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-painting/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-painting/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-painting/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-painting/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-painting/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Paintings on sale',
              link: '/art/product_category-painting/in_sale-on/',
            },
            {
              text: `Paintings under ${currencySymbol}500`,
              link: '/art/product_category-painting/price_max-500/',
            },
          ],
          highlights: [{text: 'Browse all paintings', link: '/art/product_category-painting/'}],
        },
      ],
    },
    {
      text: 'Prints',
      link: '/art/product_category-prints/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-prints/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-prints/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-prints/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-prints/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-prints/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-prints/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-prints/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-prints/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-prints/subject-still-life/',
            },
          ],
        },
        {
          title: 'Handmade',
          links: [
            {
              text: 'Collagraphs',
              link: '/art/product_category-prints/prints-prints-collagraphs/',
            },
            {
              text: 'Etchings & engravings',
              link: '/art/product_category-prints/prints-prints-echings-engravings/',
            },
            {
              text: 'Monoprint',
              link: '/art/product_category-prints/prints-prints-monoprint/',
            },
            {
              text: 'Screenprint',
              link: '/art/product_category-prints/prints-prints-screenprints/',
            },
            {
              text: 'Lithograph',
              link: '/art/product_category-prints/prints-prints-lithographs/',
            },
            {
              text: 'Linocuts',
              link: '/art/product_category-prints/prints-prints-linocuts/',
            },
            {
              text: 'Woodcuts',
              link: '/art/product_category-prints/prints-prints-woodcuts/',
            },
          ],
        },
        {
          title: 'Digital',
          links: [
            {
              text: 'C-Type',
              link: '/art/product_category-prints/prints-prints-c-type',
            },
            {
              text: 'Giclée',
              link: '/art/product_category-prints/prints-prints-giclee',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-prints/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-prints/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-prints/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-prints/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-prints/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-prints/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Prints on sale',
              link: '/art/product_category-prints/in_sale-on/',
            },
            {
              text: `Prints under ${currencySymbol}500`,
              link: '/art/product_category-prints/price_max-500/',
            },
          ],
          highlights: [{text: 'Browse all prints', link: '/art/product_category-prints/'}],
        },
      ],
    },
    {
      text: 'Photography',
      link: '/art/product_category-photography/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-photography/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-photography/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-photography/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-photography/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-photography/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-photography/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-photography/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-photography/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-photography/subject-still-life/',
            },
          ],
        },
        {
          title: 'Medium',
          links: [
            {
              text: 'Black & white',
              link: '/art/product_category-photography/photography-photography-black-and-white/',
            },
            {
              text: 'Colour',
              link: '/art/product_category-photography/photography-photography-colour/',
            },
            {
              text: 'Manipulated',
              link: '/art/product_category-photography/photography-photography-manipulated/',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-photography/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-photography/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-photography/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-photography/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-photography/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-photography/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Photography on sale',
              link: '/art/product_category-photography/in_sale-on/',
            },
            {
              text: `Photography under ${currencySymbol}500`,
              link: '/art/product_category-photography/price_max-500/',
            },
          ],
          highlights: [
            {text: 'Browse all photography', link: '/art/product_category-photography/'},
          ],
        },
      ],
    },
    {
      text: 'Sculpture',
      link: '/art/product_category-sculpture/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-sculpture/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-sculpture/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-sculpture/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-sculpture/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-sculpture/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-sculpture/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-sculpture/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-sculpture/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-sculpture/subject-still-life/',
            },
          ],
        },
        {
          title: 'Medium',
          links: [
            {
              text: 'Bronze',
              link: '/art/product_category-sculpture/sculpture-sculpture-bronze/',
            },
            {
              text: 'Clay',
              link: '/art/product_category-sculpture/sculpture-sculpture-clay/',
            },
            {
              text: 'Mixed media',
              link: '/art/product_category-sculpture/sculpture-sculpture-mixed-media/',
            },
            {
              text: 'Relief',
              link: '/art/product_category-sculpture/sculpture-sculpture-relief/',
            },
            {
              text: 'Stone',
              link: '/art/product_category-sculpture/sculpture-sculpture-stone/',
            },
            {
              text: 'Wood',
              link: '/art/product_category-sculpture/sculpture-sculpture-wood/',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-sculpture/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-sculpture/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-sculpture/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-sculpture/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-sculpture/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-sculpture/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Sculptures on sale',
              link: '/art/product_category-sculpture/in_sale-on/',
            },
            {
              text: `Sculptures under ${currencySymbol}500`,
              link: '/art/product_category-sculpture/price_max-500/',
            },
          ],
          highlights: [{text: 'Browse all sculptures', link: '/art/product_category-sculpture/'}],
        },
      ],
    },
    {
      text: 'Drawing',
      link: '/art/product_category-drawing/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-drawing/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-drawing/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-drawing/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-drawing/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-drawing/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-drawing/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-drawing/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-drawing/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-drawing/subject-still-life/',
            },
          ],
        },
        {
          title: 'Medium',
          links: [
            {
              text: 'Charcoal',
              link: '/art/product_category-drawing/drawing-drawing-charcoal/',
            },
            {
              text: 'Ink',
              link: '/art/product_category-drawing/drawing-drawing-ink/',
            },
            {
              text: 'Pastel',
              link: '/art/product_category-drawing/drawing-drawing-pastel/',
            },
            {
              text: 'Pencil',
              link: '/art/product_category-drawing/drawing-drawing-pencil/',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-drawing/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-drawing/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-drawing/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-drawing/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-drawing/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-drawing/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Drawings on sale',
              link: '/art/product_category-drawing/in_sale-on/',
            },
            {
              text: `Drawings under ${currencySymbol}500`,
              link: '/art/product_category-drawing/price_max-500/',
            },
          ],
          highlights: [{text: 'Browse all drawings', link: '/art/product_category-drawing/'}],
        },
      ],
    },
    {
      text: 'Collage',
      link: '/art/product_category-collage/',
      submenu: [
        {
          title: 'Subject',
          links: [
            {
              text: 'Abstract & conceptual',
              link: '/art/product_category-collage/subject-abstract-conceptual/',
            },
            {
              text: 'Animals & birds',
              link: '/art/product_category-collage/subject-animals-birds/',
            },
            {
              text: 'Architecture & cities',
              link: '/art/product_category-collage/subject-architecture-cityscapes/',
            },
            {
              text: 'Cars, bikes & transport',
              link: '/art/product_category-collage/subject-transportation-maps/',
            },
            {
              text: 'Flowers & plants',
              link: '/art/product_category-collage/subject-flowers-plants/',
            },
            {
              text: 'Landscapes, sea & sky',
              link: '/art/product_category-collage/subject-landscapes-sea-sky/',
            },
            {
              text: 'Nudes & erotic',
              link: '/art/product_category-collage/subject-nudes-erotic/',
            },
            {
              text: 'People & portraits',
              link: '/art/product_category-collage/subject-people-portraits/',
            },
            {
              text: 'Still life',
              link: '/art/product_category-collage/subject-still-life/',
            },
          ],
        },
        {
          title: 'Style',
          links: [
            {
              text: 'Abstract',
              link: '/art/product_category-collage/style-abstract/',
            },
            {
              text: 'Expressionistic',
              link: '/art/product_category-collage/style-expressive-and-gestural/',
            },
            {
              text: 'Impressionistic',
              link: '/art/product_category-collage/style-impressionistic/',
            },
            {
              text: 'Photorealistic',
              link: '/art/product_category-collage/style-photorealistic/',
            },
            {
              text: 'Surrealistic',
              link: '/art/product_category-collage/style-surrealistic/',
            },
            {
              text: 'Urban & pop',
              link: '/art/product_category-collage/style-urban-and-pop/',
            },
          ],
        },
        {
          links: [
            {
              text: 'Collages on sale',
              link: '/art/product_category-collage/in_sale-on/',
            },
            {
              text: `Collages under ${currencySymbol}500`,
              link: '/art/product_category-collage/price_max-500/',
            },
          ],
          highlights: [{text: 'Browse all collages', link: '/art/product_category-collage/'}],
        },
      ],
    },
    {
      text: 'Inspiration',
      link: '/editors-picks/',
      submenu: [
        {
          title: 'Editors’ Picks',
          links: editorsPicks.map((pick) => ({text: pick.name, link: pick.url})),
          highlights: [{text: `All editors' picks`, link: '/editors-picks/'}],
        },
        {
          title: 'Artists',
          links: [
            {
              text: 'Bestsellers',
              link: '/artist-charts/top-40-artists/',
            },
            {
              text: 'Artists of the month',
              link: '/staff-picks/artists-of-the-month/',
            },
            {
              text: 'Trending artists',
              link: '/blog/category/trending-artists/',
            },
            {
              text: 'Commission an artist',
              link: '/artist-search/sort-best_match/paginate-60/acceptscommissions-true/',
            },
          ],
          highlights: [
            {
              text: 'New artists',
              link: '/artist-charts/top-40-brand-new-artists/#/',
            },
            {
              text: 'Find an artist',
              link: '/artist-search/sort-best_match/paginate-60/',
            },
          ],
        },
        {
          title: 'Ideas',
          links: [
            {
              text: 'Decor inspiration',
              link: '/blog/category/decor-inspiration-tips/',
            },
            {
              text: 'Art glossary',
              link: '/blog/category/art-glossary/',
            },
            {
              text: 'Personal shopping',
              link: '/personal-shopping/',
            },
            {
              text: 'Artfinder trade',
              link: '/trade/',
            },
          ],
        },
        {
          title: 'Sales',
          links: [
            {
              text: `${currencySymbol}500 & under`,
              link: '/art/price_max-500/',
            },
            {
              text: 'All sales',
              link: '/art/in_sale-on/',
            },
            {
              text: 'Free shipping',
              link: '/art/free_shipping-true/',
            },
          ],
          highlights: [
            {
              text: 'Gift cards',
              component: (
                <img
                  loading="lazy"
                  width="150"
                  height="79"
                  alt="Gift cards"
                  aria-label="Gift cards"
                  src="https://d2m7ibezl7l5lt.cloudfront.net/img/v2/megamenu/gift-card.svg"
                />
              ),
              link: '/products/giftcard/',
            },
          ],
        },
      ],
    },
  ];
};
